import { AuthorizationStatusEnum } from '../../../types/tracking'

export const authorizationStatusInstructions: Record<AuthorizationStatusEnum, string> = {
  [AuthorizationStatusEnum.AuthorizationStatusDenied]:
    'This device has been denied location access. Please call the driver and ask them to go to Settings > Privacy > Location Services and enable location for the app.',
  [AuthorizationStatusEnum.AuthorizationStatusRestricted]:
    'Location services are restricted on this device. Please call the driver and ask them to check their device restrictions.',
  [AuthorizationStatusEnum.AuthorizationStatusNotDetermined]:
    'Location permission has not been set. Please call the driver and ask them to open the app and allow location access.',
  [AuthorizationStatusEnum.AuthorizationStatusWhenInUse]:
    'Location is only allowed when the app is in use. Please call the driver and ask them to change location permission to "Always" in Settings.',
  [AuthorizationStatusEnum.AuthorizationStatusAlways]:
    'This device has not been authorized to use location services. Please call the driver and ask them to set the app and phone permissions to "Always".',
  [AuthorizationStatusEnum.AuthorizationStatusUnknown]:
    'This device has not been authorized to use location services. Please call the driver and ask them to set the app and phone permissions to "Always".'
}

export const messages = {
  STATIONARY_DEVICE_ALERT_MESSAGE:
    'This device has been stationary for an extended period. Please check with the driver to ensure they are still moving.'
}
